import React, { Component } from 'react';
import { generateTokenSchema, searchData } from './../../schema/generateToken';
import { filter, formData, dissableFormData } from './../../schema/apppointment';
import Select2 from '../../components/FormComponent/select2';
import Inputlayer from '../../components/FormComponent/Input';
import networkList from '../../constants/networkList';
import postService from './../../services/httpService';
import { Modal, Spin, Badge, Popover } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import userTrackService from './../../services/usertrack-service';
import { event } from 'jquery';
import { find } from 'lodash';
import Storage from './../../services/local-store';
const $ = require('jquery');
const { confirm } = Modal;
const { getPatientTrackbillInfo, homepage }=networkList
class Generate_Token extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            formData: [],
            filtereData: [],
            searchPatient: [],
            selectedData: {},
            modalData: {},
            payer_type: null,
            marital_status: null,
            pat_address: null,
            is_icu: null,
            wardname:null,
            floor:null,
            block:null,
            nursestation_name:null,
            hims_patient_type: null,
        }
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }

    generateToken() {
        this.setState((state) => ({ 'loadding': true }));
        let obj = {
            "name": null,
            "umr": null,
            "ip": null,
            "gender": null,
            "phone_number": null,
            "privilege_id": null,
            "privilege_name": null,
            "doctor_id": null,
            "payer_type": this.state.hims_patient_type? this.state.hims_patient_type:null,
            "WARDNAME":this.state.wardname?this.state.wardname:null,
            "FLOOR":this.state.floor?this.state.floor:null,
            "BLOCK":this.state.block?this.state.block:null,
            "NURSESTATION_NAME":this.state.nursestation_name?this.state.nursestation_name:null,
        }
        console.clear();
        let { formData, filtereData, payer_type } = this.state
        let errors = [];
        formData.map((data, key) => {
            if (data.rules !== undefined && Array.isArray(data.rules)) {
                formData[key]['errors'] = [];
                if(data.visible){
                    data
                    .rules
                    .map((rule, rkey) => {
                        console.log(rule.test(data['value']), data['value'], data['title']);
                        if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(data['value'])) {
                            formData[key]['errors'].push({ 'message': rule.message });
                            errors.push(false);
                        }
                    })
                }
                
            }
        });


        this.setState((state) => ({ 'formData': formData }));

        if (!errors.includes(false)) {
            obj['payer_type'] = this.state.hims_patient_type ? this.state.hims_patient_type : null
            formData.map((form) => {
                if (form['name'] === 'service_type_admission') {
                    obj['privilege_id'] = form.value;
                    obj['privilege_name'] = form.text;

                }
                if (form['name'] === 'doctor') {
                    obj['doctor_id'] = form.value;
                }
                if (form['name'] === 'counsellor') {
                    obj['tg_assigned_counsellor'] = form.value;
                }

            })
            filtereData.map((d, i) => {
                if (d.name === 'name') {
                    obj['name'] = d.value;
                }
                if (d.name === 'umr_number') {
                    obj['umr'] = d.value;
                }
                if (d.name === 'phonenumber') {
                    obj['phone_number'] = d.value;
                }
                if (d.name === 'gender') {
                    if (d.value == 'Male') {
                        obj['gender'] = 'male';
                    } else {
                        obj['gender'] = 'female';
                    }
                }
                if (d.name === 'age') {
                    obj['age'] = d.value;
                }
                if (d.name === 'ip') {
                    obj['ip'] = d.value;
                }
                if (d.name === 'marital_status') {
                    obj['marital_status'] = d.value;
                }
                if (d.name === 'pat_address') {
                    obj['pat_address'] = d.value;
                }
                if (d.name === 'is_icu') {
                    obj['is_icu'] = d.value;
                }
                

            })
           
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Patient Trackbill Info - Request",
                    "date": new Date(),
                    "meta": obj
                }
            }
            userTrackService(Userlogobj)
            
            // checking recounselling on tracklist
            if (obj && (obj['umr'] || obj['ip']) && obj['privilege_id'] == 5) {
                let userData = localStorage.getItem('user_data');
                if (userData !== undefined && userData !== null && userData !== '') {
                    userData = JSON.parse(userData);
                }
                try{
                postService(getPatientTrackbillInfo, 'POST', {
                    'data': {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "ip_no": obj['ip'] ? obj['ip'] : null,
                        "umr_no": obj['umr'] ? obj['umr'] : null,
                    }
                }).then(res => {
                    const Userlogobjres = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Patient Trackbill Info - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                    userTrackService(Userlogobjres);
                    if (res.status) {
                        // this.setState((state) => ({ 'loadding': false }));
                        if (res['data'] && res['data'].length > 0) {
                            let data = res['data'][0]['warning_flag']
                            // if(data){
                            this.generateTokenAPI(obj);
                            // }else{
                            //     Modal.info({
                            //         title: `Information`,
                            //         content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                            //         zIndex: '1022'
                            //     });
                            // }
                        } else {
                            this.setState((state) => ({ 'loadding': false }));
                            Modal.info({
                                title: `Information`,
                                content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                                zIndex: '1022'
                            });
                        }
                    } else {
                        this.setState((state) => ({ 'loadding': false }));
                        Modal.info({
                            title: `Information`,
                            content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                            zIndex: '1022'
                        });
                    }
                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }
            } else {
                this.generateTokenAPI(obj)
            }
        } else {
            this.setState((state) => ({ 'loadding': false }));
        }

    }

    generateTokenAPI = (obj) => {
        let { formData, filtereData, searchPatient } = this.state
        let { generateTokenForQueue } = networkList;
        let {umr, ip} = obj;
        let findDischargeDT;
        const matchumr = searchPatient.find(item => item.UMRNO === umr);
        if(matchumr) {
            findDischargeDT = matchumr.DIS_INITIATED_DT;
        }
        let PrivilegeName;
        let FormType;
        formData.map((data, key) => {
            if(data['name'] === 'service_type_admission'){
                PrivilegeName = data['text']
            }
        })
        let storageData = JSON.parse(Storage.get('privileges2'));
        const FormName = storageData.find(data => data.name === PrivilegeName);
        if(FormName){
            FormType = FormName.form_type_id
        }
        if(((findDischargeDT !== null || findDischargeDT && findDischargeDT.length>0) && (umr !==null || umr && umr.length>0) && (ip !==null || ip && ip.length>0)) && FormType === 1){
            this.setState((state) => ({ loadding: false}));
                Modal.info({
                    'title': 'Error Message',
                    'content': 'Patient discharge has been initiated.',
                    zIndex: 2000
                });
                // window.location.reload();
            return true
        }
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Generate Token For Queue - Request",
                "date": new Date(),
                "meta": obj
            }
        }
        this.setState({ 'loadding': true })
        userTrackService(Userlogobj);
        try {
        postService(generateTokenForQueue, 'POST', { 'data': obj }).then(res => {
            const Userlogobjres = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Generate Token For Queue - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                this.getTokensForTG();
                Storage.remove('privileges2');
                this.setState((state) => ({ 'loadding': false }));
                this.setState({
                    visible: true,
                    modalData: res.data[0]
                }, () => {
                    filtereData.map((d, i) => {
                        filtereData[i]['value'] = null;
                    })
                    formData.map((form, key) => {
                        formData[key]['value'] = null;
                        if (form['name'] === 'service_type_admission' || form['name'] === 'doctor' || form['name'] === 'patient_list') {
                            formData[key]['disable'] = true;
                            delete formData[key]['text']
                        }
                        if(form['name'] === 'doctor'){
                            formData[key]['className']='col-8';
                        }
                        if(form['name']==='counsellor'){
                            formData[key]['visible'] = false;
                            delete formData[key]['text']
                        }

                    })
                    this.setState((state) => ({ 'formData': formData, 'filtereData': filtereData, 'payer_type': null,wardname:null,floor:null,block:null,nursestation_name:null}));
                })
            } else {
                this.setState((state) => ({ 'loadding': false }));
                    Modal.error({
                        title: 'Error message',
                        content: res.messsage,
                    });                
            }
        })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
    }
    componentDidMount() {
        this.getTokensForTG();
        this.interval = setInterval(() => { this.getTokensForTG() }, 20000);
        this.setState((state) => ({ 'loadding': true, 'formData': generateTokenSchema['feilds'], 'filtereData': searchData['feilds'] }), () => {
            let { formData, filtereData } = this.state
            filtereData.map((d, i) => {
                filtereData[i]['value'] = null;
            })
            formData.map((form, key) => {
                formData[key]['value'] = null;
                if (form['name'] === 'service_type_admission' || form['name'] === 'doctor' || form['name'] === 'patient_list') {
                    formData[key]['disable'] = true;
                    delete formData[key]['text']
                }

            })
            this.setState((state) => ({ 'loadding': false, 'formData': formData, 'filtereData': filtereData }));
        })
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    handleCancel = e => {
        console.log(e)
        this.setState({ visible: false })
    }
    print = () => {
        this.setState({ visible: false });
        window.print();
    }

    formonChange(evnt) {
        console.clear();
        console.log(evnt);
        let formData = this.state.formData;
        let filtereData = this.state.filtereData;
        let patient_list_val = false;
        let {pat_address, marital_status, is_icu}=this.state
        // let patientType = null;
        // let payment_type = null
        // let billStatus = null;
        // let billnumber = null;
        // let { checkPatientbill } = networkList;
        formData.map((data, key) => {

            if (data['name'] === evnt.name) {
                formData[key]['value'] = evnt.value;
                formData[key]['valid'] = true;
            }
            if (data['name'] === 'patient_list' && data['value'] !== null && data['value'] !== '') {
                patient_list_val = true;
            }
            if (patient_list_val) {
                if (data['name'] === 'service_type_admission') {
                    formData[key]['disable'] = false;
                    //formData[key]['value'] = null;
                    // delete formData[key]['text'];
                }
                if (data['name'] === 'doctor') {
                    formData[key]['disable'] = false;
                    //formData[key]['value'] = null;
                    // delete formData[key]['text'];

                }
                
            }

            if (!patient_list_val) {
                if (data['name'] === 'service_type_admission') {
                    formData[key]['disable'] = true;
                    formData[key]['value'] = null;
                    delete formData[key]['text'];
                }
                if (data['name'] === 'doctor') {
                    formData[key]['disable'] = true;
                    formData[key]['value'] = null;
                    delete formData[key]['text'];
                }
                if (data['name'] === 'counsellor') {
                    formData[key]['disable'] = true;
                    formData[key]['value'] = null;
                    delete formData[key]['text']; 
                }
            }

            // if (data['name'] === 'patient_type') {
            //     patientType = data['value'];
            // }
            // if (data['name'] === 'payment_status') {
            //     payment_type = data['value'];
            // }

            // if (data['name'] === evnt.name && evnt.name === 'bill_no') {

            //     data['errors'] = [];
            //     billnumber = evnt.value;
            //     let postData = { "data": { "patientType": patientType, "billnumber": billnumber } }
            //     postService(checkPatientbill, 'POST', postData).then(res => {
            //         if (res) {
            //             console.log("billing checking.....");
            //             console.log(res);
            //             if (res.status) {
            //                 if (res.data === 'valid') {
            //                     this.setState((state) => ({ billStatus: true }), () => {
            //                         this.validateForm(formData);
            //                     });
            //                     data['valid'] = true;
            //                 } else {
            //                     this.setState((state) => ({ billStatus: false }), () => {
            //                         this.validateForm(formData);
            //                     });
            //                     data['valid'] = false;
            //                 }

            //             }
            //         } else {
            //             this.setState((state) => ({ billStatus: false }), () => {
            //                 this.validateForm(formData);
            //             });
            //             data['valid'] = false;
            //         }
            //     });

            // }
            // return data;
        });
        if (evnt.name === 'patient_list') {
            let patient_details = '{' + evnt.value + '}';
            let patient = JSON.parse(patient_details);
            console.log('patient:',patient);
            filtereData.map((d, i) => {
                if (d.name === 'name') {
                    d['value'] = patient.NAME;
                    d['disable'] = true;
                }
                if (d.name === 'umr_number') {
                    d['value'] = patient.UMR;
                    d['disable'] = true;
                }
                if (d.name === 'phonenumber') {
                    d['value'] = patient.MOBILENO;
                    d['disable'] = true;
                }
                if (d.name === 'gender') {
                    if (patient.GENDER == 'M' || patient.GENDER == 'Male') {
                        d['value'] = 'Male';
                    } else {
                        d['value'] = patient.GENDER;
                    }

                    d['disable'] = true;
                }
                if (d.name === 'age') {
                    d['value'] = patient.AGE;
                    d['disable'] = true;
                }
                if (d.name === 'ip') {
                    d['value'] = patient.IP;
                    d['disable'] = true;
                }
                if (d.name === 'marital_status') {
                    d['value'] = marital_status;
                    d['disable'] = true;
                }
                if (d.name === 'pat_address') {
                    d['value'] = pat_address;
                    d['disable'] = true;
                }
                if (d.name === 'is_icu') {
                    d['value'] = is_icu;
                    d['disable'] = true;
                }
                return d;
            })
            this.setState((state) => ({ 'filtereData': filtereData, hims_patient_type: evnt.patient_type_hims}));
        }
        if(evnt.name==="service_type_admission"){
            formData.map((data, key) => {
                if(evnt.value===5){
                    if (data['name'] === 'doctor') {
                        formData[key]['className']='col-4';
                    }
                    if (data['name'] === 'counsellor') {
                        localStorage.setItem('privilege_id', evnt.value);
                        formData[key]['visible'] = true;
                        formData[key]['disable'] = false;
                    }
                }
                else{
                    if (data['name'] === 'doctor') {
                        formData[key]['className']='col-8';
                    }
                    if (data['name'] === 'counsellor') {
                    formData[key]['visible'] = false;
                    formData[key]['disable'] = false;
                    }
                }
            })
        }





        this.setState((state) => ({ formData: formData }), () => {
            this.validateForm(formData);
        });

    }

    SearchEvent() {
        this.setState((state) => ({ 'loadding': true }));
        let formData = this.state.formData;
        let {hims_patient_type} = this.state;
        let filtereData = this.state.filtereData;
        let data = [];
        if (formData !== undefined) {
            formData.map((feild, key) => {
                formData[key]['error'] = [];
                if (feild.name === 'umr' && feild.value !== null && feild.value !== '') {
                    data.push(true);
                }
                if (feild.name === 'mobile' && feild.value !== null && feild.value !== '') {
                    var regex = /^\d{10}$/g;
                    let value = parseInt(feild.value);
                    console.log(regex.test(value), regex.test(feild.value), feild.value, value)
                    if (value !== null && value.length > 0 && regex.test(value) === false) {
                        data.push(false);
                    } else {
                        if (regex.test(value) === true) {
                            data.push(true);
                        }
                    }

                }
                if (feild.name === 'ipnumber' && feild.value !== null && feild.value !== '') {
                    data.push(true);
                }
            })


            if (!data.includes(false) && data.includes(true) && data.length >= 1) {
                let payload = { "patientidentity": null, "MOBILENO": null, "patienttype": "OP", "ADMISSIONNO": "", "UMRNO": "" };
                formData.map((fmdata, fmkey) => {

                    if (fmdata.name === 'umr' && fmdata.value !== null) {
                        payload["UMRNO"] = fmdata.value;
                        // payload = { "patientidentity": fmdata.value, "mobileno": "", "patienttype": "OP" }
                    }
                    if (fmdata.name === 'mobile' && fmdata.value !== null) {
                        payload["MOBILENO"] = fmdata.value;
                        // payload = { "patientidentity": null, "mobileno": fmdata.value, "patienttype": "OP" }
                    }
                    if (fmdata.name === 'ipnumber' && fmdata.value !== null) {
                        payload["ADMISSIONNO"] = fmdata.value;
                        payload["patienttype"] = "IP";
                        // payload = { "patientidentity": fmdata.value, "mobileno": "", "patienttype": "IP" }

                    }
                });
                let userData = localStorage.getItem('user_data');
                if (userData !== undefined && userData !== null && userData !== '') {
                    userData = JSON.parse(userData);
                }
                payload["unit_id"] = userData ? userData['unitid'] ? userData['unitid'] : null : null;
                let { getPatientDetailsForQueue } = networkList;
                postService(getPatientDetailsForQueue, 'POST', { 'data': payload }).then(res => {
                    if (res.status) {

                        if (res.data && Array.isArray(res.data) && res.data.length !== 0) {
                            // console.log("res.data 553",res.data);
                            // const discharge = res.data.map((Y) => Y.DIS_INITIATED_DT === null);
                            // const hasDischargedPatients = discharge.some((isDischarged) => isDischarged === false);
                            // console.log("discharge 555",hasDischargedPatients);
                            // if(hasDischargedPatients){
                            //     this.setState((state) => ({ loadding: false}));
                            //     Modal.info({
                            //         'title': 'Error Message',
                            //         'content': 'Patient discharge has been initiated.',
                            //         zIndex: 2000
                            //     });
                            //     // window.location.reload();
                            //     this.setState({'marital_status': null, 'pat_address': null, 'is_icu': null})
                            //     formData.map((fmdata, fmkey) => {
                            //         if (fmdata.name === 'patient_list') {
                            //             formData[fmkey]['disable'] = true;  
                            //             formData[fmkey]['value'] = null;
                            //             delete formData[fmkey]['text']
                            //             filtereData.map((d, i) => {
                            //                 d['value'] = null;
                            //                 return d;
                            //             })
                            //             this.setState((state) => ({ 'filtereData': filtereData }));
                            //         }

                            //         if (fmdata['name'] === 'service_type_admission') {
                            //             formData[fmkey]['disable'] = true;
                            //             formData[fmkey]['value'] = null;
                            //             delete formData[fmkey]['text'];
                            //         }
                            //         if (fmdata['name'] === 'doctor') {
                            //             formData[fmkey]['disable'] = true;
                            //             formData[fmkey]['className']='col-8';
                            //             formData[fmkey]['value'] = null;
                            //             delete formData[fmkey]['text'];
                            //         }
                            //         if (fmdata['name'] === 'counsellor') {
                            //             formData[fmkey]['disable'] = false;
                            //             formData[fmkey]['visible'] = false;
                            //             formData[fmkey]['value'] = null;
                            //             delete formData[fmkey]['text'];
                            //         }

                            //     });
                            //     return true;
                            // }
                             res.data=res.data.filter((x)=>x.ISOSP!=='YES');
                            this.setState({'marital_status': res['data'][0]['MARITALSTATUS'], 'pat_address': res['data'][0]['PAT_ADDRESS'], 'is_icu': (res['data'][0]['IS_ICCU'] && res['data'][0]['IS_ICCU'] == 'YES') ? 1 : 0,wardname:res['data'][0]['WARDNAME']?res['data'][0]['WARDNAME']:null,floor:res['data'][0]['FLOOR']?res['data'][0]['FLOOR']:null,block:res['data'][0]['BLOCK']?res['data'][0]['BLOCK']:null,nursestation_name:res['data'][0]['NURSESTATION_NAME']?res['data'][0]['NURSESTATION_NAME']:null  })
                            // console.log('resget:',res)
                            formData.map((fmdata, fmkey) => {
                                if (fmdata.name === 'patient_list') {
                                    formData[fmkey]['disable'] = false;
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                    filtereData.map((d, i) => {
                                        d['value'] = null;
                                        return d;
                                    })
                                    this.setState((state) => ({ 'filtereData': filtereData }));
                                }                               

                                if (fmdata['name'] === 'service_type_admission') {
                                    formData[fmkey]['disable'] = false;
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                }
                                if (fmdata['name'] === 'doctor') {
                                    formData[fmkey]['disable'] = false;
                                    formData[fmkey]['className']='col-8';
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                }
                                if (fmdata['name'] === 'counsellor') {
                                    formData[fmkey]['disable'] = false;
                                    formData[fmkey]['visible'] = false;
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                }

                            });
                        } else {
                            Modal.info({
                                title: 'Message',
                                content: 'No record found with the given details',

                            });
                            this.setState({'marital_status': null, 'pat_address': null, 'is_icu': null})
                            formData.map((fmdata, fmkey) => {
                                if (fmdata.name === 'patient_list') {
                                    formData[fmkey]['disable'] = true;  
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text']
                                    filtereData.map((d, i) => {
                                        d['value'] = null;
                                        return d;
                                    })
                                    this.setState((state) => ({ 'filtereData': filtereData }));
                                }

                                if (fmdata['name'] === 'service_type_admission') {
                                    formData[fmkey]['disable'] = true;
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                }
                                if (fmdata['name'] === 'doctor') {
                                    formData[fmkey]['disable'] = true;
                                    formData[fmkey]['className']='col-8';
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                }
                                if (fmdata['name'] === 'counsellor') {
                                    formData[fmkey]['disable'] = false;
                                    formData[fmkey]['visible'] = false;
                                    formData[fmkey]['value'] = null;
                                    delete formData[fmkey]['text'];
                                }

                            })
                        }
                        if (res['data'] && res['data'].length > 0) {
                            // this.setState({ 'payer_type': res['data'][0]['PATIENTTYPE'] ? res['data'][0]['PATIENTTYPE'] : null })
                            this.setState({ 'payer_type': this.state.hims_patient_type ? this.state.hims_patient_type : this.state.hims_patient_type })
                        } else {
                            this.setState({ 'payer_type': null })
                        }
                        this.setState((state) => ({ 'loadding': false, 'searchPatient': res.data, 'formData': formData }))

                    } else {
                        this.setState((state) => ({ 'loadding': false }));
                    }
                })
                // this.setState((state) => ({ formData: formData }), () => {
                //     this.validateForm(formData);
                // });
            } else {
                this.setState((state) => ({ 'loadding': false }));
                let modalShow = true;
                formData.map((fmdata, fmkey) => {
                    if (fmdata.name === 'umr') {
                        formData[fmkey]['disable'] = false;
                        formData[fmkey]['value'] = null;

                    }
                    if (fmdata.name === 'mobile') {
                        let value = fmdata['value'];
                        var regex = /^\d{10}$/g;
                        formData[fmkey]['disable'] = false;
                        formData[fmkey]['value'] = null;
                        if (value !== null && value.length > 0 && regex.test(value) === false) {
                            modalShow = false;
                            formData[fmkey]['value'] = value;
                            formData[fmkey]['errors'] = [{ 'message': 'Please Enter valid Mobile Number' }];
                        }
                    }
                    if (fmdata.name === 'ipnumber') {
                        formData[fmkey]['disable'] = false;
                        formData[fmkey]['value'] = null;
                    }
                    if (fmdata.name === 'patient_list') {
                        formData[fmkey]['disable'] = false;
                        formData[fmkey]['value'] = null;
                    }
                });
                if (modalShow) {
                    Modal.error({
                        title: 'Error message',
                        content: 'Please fill any one of the Mandatory fields',

                    });
                    formData.map((fmdata, fmkey) => {
                        if (fmdata.name === 'patient_list') {
                            formData[fmkey]['disable'] = true;                                
                            formData[fmkey]['value'] = null;
                            delete formData[fmkey]['text']
                            filtereData.map((d, i) => {
                                d['value'] = null;
                                return d;
                            })
                        }
                        if (fmdata['name'] === 'service_type_admission') {
                            formData[fmkey]['disable'] = true;
                            formData[fmkey]['value'] = null;
                            delete formData[fmkey]['text'];
                        }
                        if (fmdata['name'] === 'doctor') {
                            formData[fmkey]['disable'] = true;
                            formData[fmkey]['value'] = null;
                            delete formData[fmkey]['text'];
                        }
                    })
                }
                this.setState((state) => ({ 'formData': formData }))
                return false;
            }

        } else {
            this.setState((state) => ({ 'loadding': false }));
        }
    }

    validateForm(formData) {

        let { billStatus } = this.state;
        let dataNull = false;
        formData.map((data, key) => {
            if (data['element'] === 'select2' || data['element'] === 'input') {
                formData[key]['errors'] = [];
                if (data['name'] === 'payment_status' || data['name'] === 'bill_no') {
                    formData[key]['disable'] = true;
                }
                if (data['name'] === 'patient_type' && data['value'] !== 'op' && data['value'] !== 'ip') {
                    dataNull = true
                }

                if (dataNull && (data['name'] === 'payment_status' || data['name'] === 'bill_no')) {
                    formData[key]['valid'] = false;
                    formData[key]['value'] = null;
                    billStatus = null;
                }


                data
                    .rules
                    .map((rule, rkey) => {
                        if (rule.verify !== undefined && typeof rule.verify === 'function') {
                            if (rule.verify(formData)) {
                                formData[key]['disable'] = false;
                            }
                        }
                        if (rule.test !== undefined && typeof rule.test === 'function' && rule.test(data['value'])) {

                            if (billStatus === false && data['name'] === 'bill_no') {
                                formData[key]['errors'].push({ 'message': "Bill Number is Invalid" });
                            } else {
                                formData[key]['errors'] = [];
                            }
                        }
                    })
            }
        });

        this.setState((state) => ({ formData: formData }));
    }


    cancelToken = (data) => {    
        let This = this    
         confirm({
             title: `Are you sure to cancel the Token?`,
             icon: <ExclamationCircleOutlined />,
             content: (
                 <div className="text-center" style={{position: 'relative', marginLeft: '-38px'}}>
                 <h1>{ data ? data.current_token_count : '--'}</h1>
                 <h6 className="mb-0">{ data ? data.patient_name : '--'}</h6>
                 </div>
             ),
             onOk() {
                 try {
                     let { cancelToken } = networkList;
                     if(data && data.id){
                        const Userlogobj ={
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Cancel Token - Request",
                                "date": new Date(),
                                "meta": {
                                    "token_id": data.id,
                                    "ip" :data.ip?data.ip:null,
                                    "umr" :data.umr?data.umr:null
                                }
                            }
                        }
                        userTrackService(Userlogobj);
                       let username= JSON.parse(localStorage.getItem('user'));
                         postService(cancelToken, 'POST', { "data": { "token_id": data.id,'cancelled_by':username} }).then(res => {
                            const Userlogobjres ={
                                "data": {
                                    "user": JSON.parse(localStorage.getItem('user')),
                                    "action": "cancel Token - Response",
                                    "date": new Date(),
                                    "meta": res
                                }
                            }
                            userTrackService(Userlogobjres);
                             console.log('cancelToken:',res)
                             if (res.status) {
                                 This.getTokensForTG();
                                 Modal.success({
                                     title: 'Success',
                                     content: "Token has been cancelled."
                                 });
                             }
                             else {
                                 // to catch api errors like --> network,url,outof status 1,0
                                 Modal.error({
                                     title: 'Failure',
                                     content: "Oops! something went wrong... Please try again."
                                 });
                             }
                         })
                     } else {
                         // to catch api errors like --> network,url,outof status 1,0
                         Modal.error({
                             title: 'Failure',
                             content: "Oops, something went wrong... Please try again."
                         });
                     }
                   
                 } catch (error) {
                     console.log(error);
                     Modal.error({
                         title: 'Failure',
                         content: "Oops, something went wrong... Please try again.",
                     });
                 }
             },
             onCancel() {
               console.log('Cancel');
             },
           });       
     }
 
     getTokensForTG = () => {
         try {
             let { getTokensForTG } = networkList;
             postService(getTokensForTG, 'GET', null).then(res => {
                 console.log('getTokensForTG:',res)
                 if (res.status) {
                   
                     this.setState((state) => ({ patientQueue: res.data }));
                 }
                 else {
                     // to catch api errors like --> network,url,outof status 1,0
                     Modal.error({
                         title: 'Failure',
                         content: "Oops! something went wrong... Please try again."
                     });
                 }
             })
         } catch (error) {
             console.log(error);
             Modal.error({
                 title: 'Failure',
                 content: "Oops, something went wrong... Please try again.",
             });
         }
     }
 
     recall = (data) => {
         try {
             let { recallToken } = networkList;
             if(data && data.id) {
                const Userlogobj ={
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Recall Token - Request",
                        "date": new Date(),
                        "meta": {
                            "token_id": data.id,
                            "ip" :data.ip?data.ip:null,
                            "umr" :data.umr?data.umr:null
                        }
                    }
                }
                userTrackService(Userlogobj);
                 postService(recallToken, 'POST', { "data": { "token_id": data.id} }).then(res => {
                    const Userlogobjres ={
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Recall Token - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                    userTrackService(Userlogobjres);
                     console.log('recallToken:',res)
                     if (res.status) {
                         Modal.success({
                             title: 'Recalling the Token Number.',
                             content: (
                                 <div className="text-center" style={{position: 'relative', marginLeft: '-38px'}}>
                                 <h1>{ data ? data.current_token_count : '--'}</h1>
                                 <h6 className="mb-0">{ data ? data.patient_name : '--'}</h6>
                                 </div>
                             ),
                         });
                     }
                     else {
                         // to catch api errors like --> network,url,outof status 1,0
                         Modal.error({
                             title: 'Failure',
                             content: "Oops! something went wrong... Please try again."
                         });
                     }
                 })
             } else {
                 // to catch api errors like --> network,url,outof status 1,0
                 Modal.error({
                     title: 'Failure',
                     content: "Oops, something went wrong... Please try again."
                 });
             }
           
         } catch (error) {
             console.log(error);
             Modal.error({
                 title: 'Failure',
                 content: "Oops, something went wrong... Please try again.",
             });
         }
     }

    render() {
        let { formData, filtereData, modalData, patientQueue } = this.state
        return (
            <div className="row m-5">
                    <div className="col-3 pl-0">
                        <Badge count={patientQueue ? patientQueue.length : 0} style={{ backgroundColor: '#ffffff', color: '#000' }} >
                            <div className="card mb-5">
                                <div className="patient-queue-title">
                                <h3 className="text-center mb-0 py-4">Tokens List</h3>
                                </div>                                
                               
                                {patientQueue && patientQueue.length !=0 ?  <React.Fragment>
                                    <div className="patient-queue">
                                    {patientQueue.map((data, key) => {
                                            return (<div className="borderb" id={key}>
                                                        <div className="clearfix">
                                                            <h4 className="float-left">{data.current_token_count ? data.current_token_count : '---'}</h4>
                                                            {data.current_workflow_stageid === '1' ? 
                                                            <button type="button" className="btn btn-danger float-right" onClick={()=>{this.cancelToken(data)}}>Cancel</button>                                                        
                                                            : 
                                                            <button type="button" className="btn btn-success float-right" onClick={()=>{this.recall(data)}}>Recall</button> 
                                                            }                                                       
                                                        </div>                                            
                                                        <h6>{data.patient_name ? data.patient_name : '---'}</h6>
                                                        <h6> {
                                    <Popover placement="topRight"  content={<div ><p className="row"><span className="col-4 tgdoctor">Doctor:</span><span className="col-8">{data.doctor_name?"DR."+data.doctor_name:'----'}</span></p>
                                     <p className="row"><span className="col-4 tgdepartment">Department:</span><span className="col-8"> {data.department_name ? data.department_name  : '---'}</span></p></div>
                                   } 
                                    >
                                      <ExclamationCircleOutlined className="infotg"/> {data.umr ? data.umr : '---'}
                                    </Popover>
                               } </h6>
                                        {/* data.umr ? data.umr : '---'} */}
                                                       
                                                        <h6>{data.counsellor_name ? data.counsellor_name : '---'}</h6>  
                                                                                                 
                                                    </div>
                                                    )
                                        })
                                    }
                                  </div>
                                    </React.Fragment>
                                : 
                                <div className="my-auto text-center pt-5 bg-white" style={{height: '630px'}}>
                                    <img src={homepage+"/assets/images/icons/no-data.svg"} />
                                    <p className="no-data mb-0">No Data</p>
                                </div>
                                }
                                  
                            </div>
                        </Badge>
                    </div>
                    <div className="col-9 pr-0">
            <div className="card py-5 generate-token">
                <Spin spinning={this.state.loadding}>
                    <form noValidate>
                        <div className="row mx-auto">
                            {formData
                                .map((feild, key) => {
                                    if (feild.element === 'label') {
                                        return (
                                            <div className="col-xl-12 mb-4" key={key}>
                                                <div className="mx-auto">
                                                    <h1 className="text-heading text-center">{feild.title}</h1>
                                                </div>
                                            </div>
                                        );
                                    }
                                    if (feild.element === 'input') {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col'} my-2 ${feild.name}`}
                                                key={key}>
                                                <label className="data-label w-100">{feild.title}</label>
                                                <Inputlayer
                                                    {...this.props}
                                                    {...this.state}
                                                    feildData={feild}
                                                    onInputChanges={this
                                                        .formonChange
                                                        .bind(this)}
                                                />
                                            </div>

                                        );
                                    }
                                    if (feild.element === 'button') {
                                        return (
                                            <div className="col-3 my-1 pt-4" key={key}>
                                                <button
                                                    type="button"
                                                    className="btn btn-success btn-block"
                                                    onClick={this.SearchEvent.bind(this)}
                                                >{feild.text}</button>
                                            </div>
                                        );
                                    }

                                    if (feild.element === 'select2'&& feild.visible===true) {
                                        return (
                                            <div class="col-12 mt-5 mb-5">
                                                {(feild.name === 'patient_list') &&
                                                    <div className="col-6 pl-0">
                                                        <p className="mb-0 text-black" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="data-label" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Select Patient</p>
                                                    </div>}
                                                <Select2
                                                    Queuedata={formData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                    onselectChanges={this
                                                        .formonChange
                                                        .bind(this)} /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}

                                            </div>
                                        )
                                    }
                                })}
                        </div>
                    </form>

                    <div className="row mx-auto pb-4">
                        {filtereData.map((data, key) => {
                            if(data['visible']){
                            if(data.name === 'pat_address'){
                                return (<div className="col-xl-8 col-lg-8 col-sm-16 d-flex">
                                <p className="data-label">{data.title}</p>
                                <p className="data-item">: {(data.value && data.value !== null) ? data.value : '--'}</p>
                            </div>)
                            }else{
                            return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                                <p className="data-label">{data.title}</p>
                                <p className="data-item">: {(data.value && data.value !== null) ? data.value : '--'}</p>
                            </div>)}
                            }
                        })}

                        {/* <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">UMR </p>
                        <p className="data-item">: UMP123456879</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">IP </p>
                        <p className="data-item">: IP123456789</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">Gender </p>
                        <p className="data-item">: Male</p>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                        <p className="data-label">Phone </p>
                        <p className="data-item">: +919988774455</p>
                    </div> */}
                    </div>
                    <div className="row mx-auto pb-5">
                        {formData
                            .map((feild, key) => {
                                if (feild.element === 'sellect' && feild.visible===true) {
                                    return (
                                        <div
                                            className={`${feild.className
                                                ? feild.className
                                                : 'col '} my-2 ${feild.name}`}
                                            key={key}>
                                            <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                            <Select2
                                                Queuedata={formData}
                                                selectdata={feild}
                                                {...this.props}
                                                {...this.state}
                                                onselectChanges={this
                                                    .formonChange
                                                    .bind(this)} /> {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}
                                        </div>
                                    );
                                }
                            })}
                    </div>
                    <div className="row mx-auto">
                        <button className="btn btn-next mx-auto" onClick={this.generateToken.bind(this)}>Generate Token</button>
                        <Modal visible={this.state.visible} onCancel={this.handleCancel} footer={null} maskClosable={false}>
                            <div className="text-center token-popup p-5">
                                <p>Token Number</p>
                                <h1>{modalData.current_token_count}</h1>
                                <h3>{modalData.umr}</h3>
                                <h2 className="text-uppercase">{modalData.patient_name}</h2>
                                <h3 className="text-capitalize">{(modalData.privilege_display_name && modalData.privilege_display_name !== null) ? modalData.privilege_display_name : '--'}</h3>
                                <p className="mt-2">{moment(modalData.token_datetime).format('MMMM Do YYYY, h:mm:ss a')}</p>
                                <div><button className="btn btn-success  text-capitalize mx-2 d-print-none" onClick={this.print}>print token</button>
                                    <button className="btn btn-danger  text-capitalize mx-2 d-print-none" onClick={this.handleCancel}>Close</button>
                                </div>
                            </div>
                            {/* <div className="text-center token-popup p-5">
                            <h3>No record found with the given details</h3>
                            <div><button className="btn btn-success btn-next text-capitalize mt-3" onClick={this.handleCancel}>close</button></div>
                        </div> */}
                        </Modal>
                    </div>
                </Spin>
            </div>
            </div>
            </div>

        )

    }
}
export default Generate_Token;